import { convertToMexicoTime } from 'utils/helpers/convertToMexicoTime';

// Función para obtener Información de vinculación
export const getVinculationInformation = (orderDetails) => [
  {
    label: 'Fecha de creación',
    value: convertToMexicoTime(orderDetails?.created),
  },
  {
    label: 'Última actualización',
    value: convertToMexicoTime(orderDetails?.updated),
  },
  {
    label: 'Línea vinculada',
    value: orderDetails?.linked_up_direct_number,
  },
  {
    label: 'Flujo de vinculación',
    value: orderDetails?.linked_up_flow,
  },
  {
    label: 'Estatus de vinculación',
    value: orderDetails?.linked_up_status,
  },
  {
    label: 'Proveedor de vinculación',
    value: orderDetails?.provider,
  },
];

// Función para obtener los identificadores
export const getIdentifiersVinculation = (orderDetails) => [
  {
    label: 'Id',
    value: orderDetails?.id,
  },
  {
    label: 'Referencia interna',
    value: orderDetails?.internal_reference,
  },
  {
    label: 'Id de flujo',
    value: orderDetails?.linked_up_flow_id,
  },
  {
    label: 'Id de estatus',
    value: orderDetails?.linked_up_status_id,
  },
  {
    label: 'Id del suscriptor',
    value: orderDetails?.mobile_subscriber_id,
  },
  {
    label: 'Id del proveedor',
    value: orderDetails?.provider_id,
  },
];

// Función para obtener detalles del pago
export const getDateDetailsPurchaseOrders = (orderDetails) => [
  {
    label: 'Fecha de Creación',
    value: convertToMexicoTime(orderDetails?.created),
  },
];
